import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleChartLine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7.5 13.5L10.5 10.5L12 12L13.5 13.5L16.5 10.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCircleChartLine.js.map